/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const HelicopterSpecification = zod.object({
  helicopterId: zod.string(),
  name: zod.string(),
  diameter: zod.number().describe("Rotor diameter in metres."),
  maximumTakeOffMass: zod.number().describe("Maximum take-off mass in kilograms."),
  landingGearType: zod.enum(["WHEELS", "SKIDS"]),
});

export type HelicopterSpecification = zod.input<typeof HelicopterSpecification>;
export type HelicopterSpecificationOutput = zod.output<typeof HelicopterSpecification>;
